"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _modal = require("../../styles/modal");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/*
    How to use: 
    <button onClick={()=>{setShowModal(!showModal);}}> Show me the Modal </button>
      <StdModal
        title={"TITLE"}
        showModal={showModal}
        closeModal={() => {

        }}
        closeOnBackgroundTouch={true} //optional
        body={<div>BODY</div>}
        isFullScreenOnMobile={false}//optional
        isFullScreen={true} //optional
        footer={<div/>} //optional
      />
*/


var StdModal = function StdModal(props) {
  var showModal = props.showModal,
      closeModal = props.closeModal,
      _props$closeOnBackgro = props.closeOnBackgroundTouch,
      closeOnBackgroundTouch = _props$closeOnBackgro === void 0 ? true : _props$closeOnBackgro,
      title = props.title,
      body = props.body,
      footer = props.footer,
      _props$isFullScreenOn = props.isFullScreenOnMobile,
      isFullScreenOnMobile = _props$isFullScreenOn === void 0 ? false : _props$isFullScreenOn,
      _props$isFullScreen = props.isFullScreen,
      isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen,
      titleStyle = props.titleStyle,
      messageStyle = props.messageStyle,
      style = props.style,
      padding = props.padding,
      centerContent = props.centerContent,
      backgroundColor = props.backgroundColor;

  var ref = _react["default"].createRef();

  return showModal ? /*#__PURE__*/_react["default"].createElement(_modal.ModalBackground, {
    isFullScreenOnMobile: isFullScreenOnMobile,
    isFullScreen: isFullScreen,
    onClick: function onClick(e) {
      if (closeOnBackgroundTouch && e.target === ref.current) {
        closeModal();
      }
    },
    padding: padding,
    centerContent: centerContent,
    backgroundColor: backgroundColor,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_modal.ModalContainerMedium, {
    isFullScreenOnMobile: isFullScreenOnMobile,
    isFullScreen: isFullScreen,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_modal.ModalHeader, null, /*#__PURE__*/_react["default"].createElement(_modal.ModalTitle, {
    titleStyle: titleStyle
  }, title), /*#__PURE__*/_react["default"].createElement(_modal.CloseButton, {
    onClick: closeModal
  }, "\xD7")), /*#__PURE__*/_react["default"].createElement(_modal.ModalMessage, {
    messageStyle: messageStyle
  }, body), footer ? /*#__PURE__*/_react["default"].createElement(_modal.ModalFooter, null, footer) : /*#__PURE__*/_react["default"].createElement("div", null))) : /*#__PURE__*/_react["default"].createElement("div", null);
};

var _default = StdModal;
exports["default"] = _default;
module.exports = exports["default"];